{
  "asIssue": "Open as an issue (first line is the title)",
  "issueActions": {"reopen": "Reopen", "resolve": "Resolve"},
  "issueReasons": {"reopen": "Reopened.", "resolve": "Resolved."},
  "issueStates": {"open": "Open", "resolved": "Resolved"},
  "issuesTitle": "Issues",
  "noIssues": "No issues yet.",
  "openIssue": "Open issue",
  "openedBy": "Opened by {{name}}",
  "placeholder": "Write a comment (Markdown)",
  "replyPlaceholder": "Reply to this issue",
  "send": "Comment",
  "termTitle": "Comments and issues on this term",
  "title": "Comments and issues"
}
